import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd139bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-background" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Looking for a trial?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Get 30 Days for free!"),
  /*#__PURE__*/_createElementVNode("h3", null, "Up to 5 devices and priority support")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.upgrade && $setup.upgrade(...args)))
      }, "Upgrade to Chief Mate"),
      _createElementVNode("button", {
        class: "noThank",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.skip && $setup.skip(...args)))
      }, " No thanks, I'll skip this really great offer... ")
    ])
  ]))
}